import setPendingCA from './setPendingCA'
import setBlankCA from './setBlankCA'
import store from '../store/index'
import pendingAction from '../assets/images/bbPendingAction.png'
import blankAction from '../assets/images/bbBlankAction.png'

function applyExtraSlotImage(combatants, combatant, caExtra, image, slotName) {
  const caField = 'ca' + caExtra
  const caNameField = 'ca_name' + caExtra
  const caSlugField = 'ca_slug' + caExtra
  const caTypeField = 'ca_type' + caExtra

  combatant[caField] = image
  combatant[caNameField] = slotName
  combatant[caSlugField] = ''
  combatant[caTypeField] = ''
}
//-------------------------------------
// load specific combatant extra image
//-------------------------------------
export default function loadSpecificCombatantExtraImage(
  idx,
  action_deletion = false,
  combatantsOverride = null,
) {
  // console.log('-----------------------------------')
  // console.log('IN loadSpecificCombatantExtraImage')
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = combatantsOverride || this_store.arena.arena_combatants
  let maxCA = this_store.config.max_ca
  let caExtra = maxCA + 1
  let caExtra_field = 'ca_slug' + caExtra
  let combatant = combatants[idx]
  //-----------------------------------------------------
  // where no existing ca-extra OR is an action deletion
  //-----------------------------------------------------

  if (!combatant) {
    return
  }

  if (combatant[caExtra_field] == '' || action_deletion) {
    //---------------
    // set slot parm
    //---------------
    let slot_parm = {
      id: combatant.id,
      ca_num: caExtra,
    }
    //------------------------------
    // if extra - set pending image
    //------------------------------
    if (combatant.extra) {
      if (combatantsOverride) {
        applyExtraSlotImage(combatants, combatant, caExtra, pendingAction, 'pending')
        return
      }

      setPendingCA(slot_parm)
      //--------------------------------
      // if NOT extra - set blank image
      //--------------------------------
    } else {
      if (combatantsOverride) {
        applyExtraSlotImage(combatants, combatant, caExtra, blankAction, 'blank')
        return
      }

      setBlankCA(slot_parm)
    }
  }
}
